import { IRootReducer } from "../../reducers";
import { IMessagesNtc } from "../../types";

export const takeMessagesNtc = (state: IRootReducer): IMessagesNtc[] =>
  state.messages.messages;
